
import { Component, Watch, Mixins } from 'vue-property-decorator';
import { labelSizes } from '@/features/common/raw';
import { UserPreferences } from '@/features/settings/types';
import { patchPreferences } from '@/features/settings/services/preferences.services';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { PreferencesMixin } from './mixins';

@Component
export default class Print extends Mixins(PreferencesMixin, ResponsivenessMixin) {
  private labelSizes = labelSizes;

  private formPrintsData = {
    labelSize: labelSizes[0],
  }

  private showPrintPreferencesAlert = {
    success: false,
    show: false,
  };

  get isUserPreferences(): number {
    return this.$store.getters.getIsUserPreferences;
  }

  get userPreferences(): UserPreferences {
    return this.$store.getters.getUserPreferences;
  }

  @Watch('isUserPreferences', { immediate: true })
  private populatePreferences(newValue: number) {
    if (newValue) {
      const { printSettings } = this.userPreferences;
      this.formPrintsData.labelSize = printSettings.labelSize;
    }
  }

  private async updatePrintPreference({ path, value }: {
    path: string,
    value: unknown,
  }) {
    this.patchPreferenceInStore(`printSettings/${path}`, value);

    const response = await patchPreferences(this.userPreferences.id, [
      {
        path: `printSettings/${path}`,
        op: 'replace',
        value,
      },
    ]);

    this.showPrintPreferencesAlert = {
      show: true,
      success: !!response,
    };
  }
}
